import React from 'react';
import { useNavigate } from 'react-router-dom';
import birdLogo from '../../assets/images/Waytern-Logo.png';
import '../../assets/componentsCSS/TopNavbar.css';

const TopNavbar = ({ isSidebarOpen }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    navigate('/');
  };

  return (
    <div className={`top-navbar ${isSidebarOpen ? 'is-sidebar-open' : ''}`}>
      {!isSidebarOpen && <img src={birdLogo} alt="Logo" className="logo1" />}
      <div className="logout-btn" onClick={handleLogout}>Logout</div>
    </div>
  );
};

export default TopNavbar;
